
import { HttpEvent, HttpEventType, HttpHandler, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApplicationLogsRequest } from "leia-api";
import { EMPTY, Observable, ReplaySubject } from "rxjs";
import { catchError, switchMap, tap } from "rxjs/operators";
import { APPLICATION_LOG_URL } from "src/app/shared/constants";

@Injectable({
  providedIn: "root"
})
export class LogQueueService {
  private _lastLogBody: string = "";
  private _queue: ReplaySubject<any>[] = [];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.endsWith(APPLICATION_LOG_URL)) {
      return next.handle(request);
    }

    const sanitizedLogBody = this._removeBodyTimestamps(request.body);
    if (this._lastLogBody === sanitizedLogBody) {
      return EMPTY;
    }

    this._lastLogBody = sanitizedLogBody;

    const requestQueueItem$ = new ReplaySubject<any>();
    const result$ = requestQueueItem$.pipe(
      switchMap(() => next.handle(request).pipe(
        tap(req => {
          if (req.type == HttpEventType.Response) {
            this.processNextRequest();
          }
        }),
        catchError(err => {
          this.processNextRequest();
          throw err;
        })
      ))
    );
    this._queue.push(requestQueueItem$);

    if (this._queue.length <= 1) {
      this.dispatchRequest();
    }

    return result$;
  }

  private _removeBodyTimestamps(body: ApplicationLogsRequest): string {
    const bodyCopy: ApplicationLogsRequest = JSON.parse(JSON.stringify(body));

    delete bodyCopy.step?.timestamp;
    bodyCopy.step?.logs?.forEach(log => delete log.timestamp);

    return JSON.stringify(bodyCopy);
  }

  private processNextRequest(): void {
    if (this._queue && this._queue.length > 0) {
      this._queue.shift();
    }
    this.dispatchRequest();
  }

  private dispatchRequest(): void {
    if (this._queue.length > 0) {
      if (this._queue.length > 1) {
        console.debug("POSSIBLE RACE CONDITION - Application Log");
      }

      const nextSubject$ = this._queue[0];
      nextSubject$.next();
      nextSubject$.complete();
    }
  }
}
